console.log('%c👍🏼 Modal', 'color: yellow');

const openModalButtons = document.querySelectorAll('.button-openModal');
openModalButtons.forEach((openModalButton) => {
    const modalId = openModalButton.getAttribute('data-ui-target');
    const modal = document.getElementById(modalId);
    const modalContent = modal.querySelector('.modal-content');
    const closeModalButton = modal.querySelector('.button-closeModal');

    const openModal = () => {
        modal.classList.remove('opacity-0', 'invisible');
        modalContent.classList.toggle('opacity-0');
        closeModalButton.focus();
    };

    const closeModal = () => {
        modal.classList.add('opacity-0', 'invisible');
        modalContent.classList.toggle('opacity-0');
        openModalButton.focus();
    };

    const trapFocus = (e) => {
        if (e.key === 'Tab') {
            const focusableElements = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
            const firstElement = focusableElements[0];
            const lastElement = focusableElements[focusableElements.length - 1];

            if (e.shiftKey) { // Shift + Tab
                if (document.activeElement === firstElement) {
                    e.preventDefault();
                    lastElement.focus();
                }
            } else { // Tab
                if (document.activeElement === lastElement) {
                    e.preventDefault();
                    firstElement.focus();
                }
            }
        }

        // Close modal on Escape
        if (e.key === 'Escape') {
            closeModal();
        }
    };

    openModalButton.addEventListener('click', openModal);
    closeModalButton.addEventListener('click', closeModal);
    document.addEventListener('keydown', trapFocus);
});
